import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const advisorClientContactStatuses = ['archived', 'active', 'hidden'] as const
export const AdvisorClientContactStatusEnumSchema = z.enum(advisorClientContactStatuses, { errorMap })
export type AdvisorClientContactStatusEnum = z.output<typeof AdvisorClientContactStatusEnumSchema>

export const advisorClientContactInvitationStatuses = ['none', 'pending', 'accepted'] as const
export const AdvisorClientContactInvitationStatusEnumSchema = z.enum(
   advisorClientContactInvitationStatuses, { errorMap }
)
